<template>
  <div>
    <div class="my-2">
      <label class="me-3">文字大小</label>
      <div class="py-2">
        <el-select v-model="fontSize" class="m-2" placeholder="Select" id="SpeedVertical" @change="changeTextLimit">
          <el-option v-for="item in (props.mode === 'center' ? fontSizeCenterObj[props.effect] : fontSizeVertical)" :key="item.value" :label="item.label"
                     :value="item.value" />
        </el-select>
      </div>
    </div>
    <template v-if="props.mode === 'center' ">
      <template v-if="props.effect === 'TransformSpot' && fontSize === 28">
        <div class="my-2" v-for="i in 6" :key="`small_${i}`">
          <label class="me-5" v-text="`輸入文字${i}`"></label>
          <el-input
              v-model="customText[i-1]"
              type="text"
              :maxlength="textMaxLimit"
              placeholder="Please input"
              show-word-limit
              clearable
          />
        </div>
      </template>
      <template v-else-if="fontSize === 25 || fontSize === 28">
        <div class="my-2" v-for="i in 5" :key="`small_${i}`">
          <label class="me-5" v-text="`輸入文字${i}`"></label>
          <el-input
              v-model="customText[i-1]"
              type="text"
              :maxlength="textMaxLimit"
              placeholder="Please input"
              show-word-limit
              clearable
          />
        </div>
      </template>
      <template v-if="fontSize === 42 || fontSize === 35 || fontSize === 48">
        <div class="my-2" v-for="j in 3" :key="`default_${j}`">
          <label class="me-5" v-text="`輸入文字${j}`"></label>
          <el-input
              v-model="customText[j-1]"
              type="text"
              :maxlength="textMaxLimit"
              placeholder="Please input"
              show-word-limit
              clearable
          />
        </div>
      </template>
      <template v-else-if="fontSize === 75">
        <div class="my-2" v-for="k in 2" :key="`large_${k}`">
          <label class="me-5" v-text="`輸入文字${k}`"></label>
          <el-input
              v-model="customText[k-1]"
              type="text"
              :maxlength="textMaxLimit"
              placeholder="Please input"
              show-word-limit
              clearable
          />
        </div>
      </template>
    </template>
    <template v-else>
      <template v-if="fontSize === 25">
        <div class="my-2" v-for="i in 9" :key="`small_${i}`">
          <label class="me-5" v-text="`輸入文字${i}`"></label>
          <el-input
              v-model="customText[i-1]"
              type="text"
              :maxlength="textMaxLimit"
              placeholder="Please input"
              show-word-limit
              clearable
          />
        </div>
      </template>
      <template v-if="fontSize === 43">
        <div class="my-2" v-for="j in 5" :key="`default_${j}`">
          <label class="me-5" v-text="`輸入文字${j}`"></label>
          <el-input
              v-model="customText[j-1]"
              type="text"
              :maxlength="textMaxLimit"
              placeholder="Please input"
              show-word-limit
              clearable
          />
        </div>
      </template>
      <template v-if="fontSize === 65">
        <div class="my-2" v-for="k in 3" :key="`large_${k}`">
          <label class="me-5" v-text="`輸入文字${k}`"></label>
          <el-input
              v-model="customText[k-1]"
              type="text"
              :maxlength="textMaxLimit"
              placeholder="Please input"
              show-word-limit
              clearable
          />
        </div>
      </template>
    </template>

    <div class="my-2">
      <label class="me-5" for="maxTemp">文字顏色</label>
      <el-color-picker color-format="rgb" v-model="customLabelTextColor[0]" />
    </div>
  </div>
</template>
<script setup>
import {computed, onMounted, ref} from "vue";
import defaultValue from "@/utils/defaultValue";

const {
  fontSizeVertical,
  fontSizeCenterVertical254275,
  fontSizeCenterVertical284275,
  fontSizeCenterVertical284875,
  fontSizeCenterVertical253575
} = defaultValue()

const fontSizeCenterObj = {
  'TwistHole': fontSizeCenterVertical254275,
  'Kaleidoscope': fontSizeCenterVertical253575,
  'Mandala': fontSizeCenterVertical254275,
  'Blossom': fontSizeCenterVertical284275,
  'TransformSpot': fontSizeCenterVertical284875,
  'TimeTunnel': fontSizeCenterVertical253575,
  'Swirl': fontSizeCenterVertical254275,
  'RainbowShoot': fontSizeCenterVertical254275,
}

const props = defineProps({
  customTexts: {
    type: Array,
    default: []
  },
  textColor: {
    type: Array,
    default: ''
  },
  textFz: {
    type: Number,
    default: 43
  },
  mode: {
    type: String,
    default: '',
    required: false
  },
  effect: {
    type: String,
    default: '',
    required: false
  }
})

const emit = defineEmits([
  'update:customTexts',
  'update:textColor',
  'update:textFz'
])

let textMaxLimit =  ref(7)


let fontSize =  computed({
  get() {return props.textFz},
  set (newValue) {
    emit('update:textFz', newValue)
  }
})


let customLabelTextColor = computed({
  get () {return props.textColor},
  set (newValue) {
    emit('update:textColor', newValue)
  }
})


let customText = computed({
  get () {return props.customTexts},
  set (newValue) {
    emit('update:customTexts', newValue)
  }
})

function changeTextLimit (fz) {
  switch (props.effect) {
    case 'TwistHole':
      switch (fz) {
        case 25:
          textMaxLimit.value =  11
          customText.value = []
          break
        case 42:
          textMaxLimit.value =  7
          customText.value = []
          break
        case 75:
          textMaxLimit.value =  3
          customText.value = []
          break
      }
      break
    case 'Kaleidoscope':
      switch (fz) {
        case 25:
          textMaxLimit.value =  10
          customText.value = []
          break
        case 35:
          textMaxLimit.value =  7
          customText.value = []
          break
        case 75:
          textMaxLimit.value =  3
          customText.value = []
          break
      }
      break
    case 'Mandala':
      switch (fz) {
        case 25:
          textMaxLimit.value =  15
          customText.value = []
          break
        case 42:
          textMaxLimit.value =  7
          customText.value = []
          break
        case 75:
          textMaxLimit.value =  6
          customText.value = []
          break
      }
      break
    case 'Blossom':
      switch (fz) {
        case 28:
          textMaxLimit.value =  11
          customText.value = []
          break
        case 42:
          textMaxLimit.value =  7
          customText.value = []
          break
        case 75:
          textMaxLimit.value =  3
          customText.value = []
          break
      }
      break
    case 'TransformSpot':
      switch (fz) {
        case 28:
          textMaxLimit.value =  11
          customText.value = []
          break
        case 48:
          textMaxLimit.value =  7
          customText.value = []
          break
        case 75:
          textMaxLimit.value =  4
          customText.value = []
          break
      }
      break
    case 'TimeTunnel':
      switch (fz) {
        case 25:
          textMaxLimit.value =  9
          customText.value = []
          break
        case 35:
          textMaxLimit.value =  7
          customText.value = []
          break
        case 75:
          textMaxLimit.value =  3
          customText.value = []
          break
      }
      break
    case 'Swirl':
      switch (fz) {
        case 25:
          textMaxLimit.value =  10
          customText.value = []
          break
        case 42:
          textMaxLimit.value =  7
          customText.value = []
          break
        case 75:
          textMaxLimit.value =  3
          customText.value = []
          break
      }
      break
    case 'RainbowShoot':
      switch (fz) {
        case 25:
          textMaxLimit.value =  14
          customText.value = []
          break
        case 42:
          textMaxLimit.value =  7
          customText.value = []
          break
        case 75:
          textMaxLimit.value =  4
          customText.value = []
          break
      }
      break
    default:
      switch (fz) {
        case 25:
          textMaxLimit.value =  1
          customText.value = []
          break
        case 43:
          textMaxLimit.value =  7
          customText.value = []
          break
        case 65:
          textMaxLimit.value =  4
          customText.value = []
          break
      }
  }

}

onMounted(() => {

})

</script>
